import React from 'react';
import { CollapsibleList } from 'taboola-ultimate-ui';
import { ListItem } from 'modules/accounts/components/ListItem/ListItem';
import styles from 'modules/campaigns/modules/common-campaign-form/components/commonEditor.module.scss';
import { FormNamespaceProvider } from 'modules/taboola-common-frontend-modules/formData/FormNamespaceProvider';
import { FormattedMessage } from '../../../i18n';
import { useExternalMetadata } from '../../hooks/useExternalMetadata';
import { MetadataInput } from '../MetadataInput/MetadataInput';

export const ExternalMetadata = ({ isRemovable, readonlyFields, options, externalMetadataKeyLabels, msgIdSuffix }) => {
    const { externalMetadata, onAdd, onRemove } = useExternalMetadata(
        isRemovable,
        readonlyFields,
        externalMetadataKeyLabels
    );

    return (
        <>
            <MetadataInput onAdd={onAdd} options={options} msgIdSuffix={msgIdSuffix} />
            <FormNamespaceProvider field="externalMetadata.data">
                <CollapsibleList
                    containerClassName={styles['list']}
                    items={externalMetadata}
                    deleteItem={onRemove}
                    listHeaderTitle={
                        <FormattedMessage id="externalMetadata.editor.list.header" defaultMessage="External Metadata" />
                    }
                    ItemComponent={ListItem}
                />
            </FormNamespaceProvider>
        </>
    );
};
